import { OtoIndividualTripSteps } from '../../lib/types/models/enrollment/oto-individual-trip-steps'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// The voyage individuel the parents recorded, plus the transfer method that decides whether the
// legs are asked for at all.
export function getOtoIndividualTripSteps(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getOtoIndividualTripSteps.url, { id: enrollmentId }))
    .get<OtoIndividualTripSteps>()
}
